<template>
  <div :class="[`mode-${mode}`]" class="progressive-image" :width="width" :height="height" ref="wrapper">
    <lazy-component ref="lazyWrapper" @show="handler" class="lazy-wrapper">
      <template v-if="mode === 'background'">
        <div :class="{ loaded: imageLoaded }" class="image" :style="backgroundImageStyle"></div>
        <div :class="{ 'fade-out': imageLoaded }" class="blur-image" :style="blurBackgroundImageStyle"></div>
      </template>
      <template v-else>
        <img v-if="imageSrc" :class="{ loaded: imageLoaded }" class="image" :alt="progressiveImage.alt" :style="customStyle" :src="imageSrc" />
        <img :class="{ 'fade-out': imageLoaded }" class="blur-image" :src="progressiveImage.loading" :alt="progressiveImage.alt" :style="customStyle" />
      </template>
    </lazy-component>
    <template v-if="mode === 'background'">
      <div :class="{ 'fade-out': imageLoaded }" class="blur-image blur-holder" :style="blurBackgroundImageStyle"></div>
    </template>
    <template v-else>
      <img class="blur-holder blur-image" :class="{ 'fade-out': imageLoaded }" :src="progressiveImage.loading" :width="width" :height="height" />
    </template>
    <img class="holder" :src="progressiveImage.holder" :width="width" :height="height" />
  </div>
</template>
<script>
import get from 'lodash/get'
import merge from 'lodash/merge'

export default {
  props: {
    lazyload: {
      type: Boolean,
      default: true,
    },
    progressiveImage: {
      type: Object,
      required: true,
    },
    alt: {
      type: String,
    },
    width: {
      type: [String, Number],
    },
    height: {
      type: [String, Number],
    },
    mode: {
      type: String,
      default: 'image',
    },
    customStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      imageLoaded: false,
      imageSrc: null,
      backgroundImageStyle: {},
    }
  },
  computed: {
    blurBackgroundImageStyle() {
      return merge({
        backgroundImage: `url('${get(this, 'progressiveImage.loading', '')}')`,
      }, this.customStyle)
    },
  },
  methods: {
    handler() {
      const imageSrc = get(this, 'progressiveImage.src')
      if (typeof window !== 'undefined' && imageSrc) {
        const image = new window.Image()
        this.backgroundImageStyle = merge({}, this.customStyle)
        if (this.mode === 'background') {
          image.onload = () => {
            this.backgroundImageStyle = merge({
              backgroundImage: `url('${imageSrc}')`,
            }, this.backgroundImageStyle)
            this.imageLoaded = true
          }
          image.onerror = () => {
            this.backgroundImageStyle = merge({
              backgroundImage: `url('${get(this, 'progressiveImage.error', '')}')`,
            }, this.backgroundImageStyle)
          }
        } else {
          image.onload = () => {
            this.imageSrc = imageSrc
            this.imageLoaded = true
          }
          image.onerror = () => {
            this.imageSrc = get(this, 'progressiveImage.error', '')
          }
        }
        image.src = imageSrc
      }
    },
  },
  watch: {
    progressiveImage() {
      if (get(this, 'progressiveImage.src')) {
        this.handler()
      }
    },
  },
}
</script>
<style scoped lang="scss">
  .mode-background {

    .lazy-wrapper {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }

    .image,
    .blur-image {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border: none;
      border-radius: 0;
      background-position: center;
      background-repeat: no-repeat;
      background-color: transparent;
      margin-left: auto;
      margin-right: auto;
      background-size: cover;
    }
  }

  img {
    position: absolute;
    width: 100%;
    height: auto;
    left: 0;
    top: 0;
  }
  .holder {
    position: relative;
    z-index: 0;
  }

  .lazy-wrapper {
    position: relative;
    z-index: 2;
  }

  .blur-image {
    opacity: 1;
    transition: opacity 4s;
    &.fade-out {
      opacity: 0;
    }
  }

  .image {
    opacity: 0;
    transition: opacity 2s;
    &.loaded {
      opacity: 1;
    }
  }

  .progressive-image {
    position: relative;
    margin: 0;
  }

  .blur-holder {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// ProgressiveImage.vue?5c76368a